import { REPORT_HUB_LINKS } from './reportHubLinks'

/**
 * Tab titles for `/reports/<segment>` list pages, taken from the hub labels so a
 * report is never named one thing on the hub and another in the browser tab.
 */
const REPORT_TITLES_BY_SEGMENT: Record<string, string> = Object.fromEntries(
  REPORT_HUB_LINKS.filter((link) => link.kind === 'react' && link.reactPath).map(
    (link) => [link.reactPath as string, link.label],
  ),
)

const REPORTS_PREFIX = '/reports/'

/** Title for a report list route, or `null` when `pathname` is not one. */
export function getReportPageTitle(pathname: string): string | null {
  if (!pathname.startsWith(REPORTS_PREFIX)) return null
  const segment = pathname.slice(REPORTS_PREFIX.length).replace(/\/+$/, '')
  return REPORT_TITLES_BY_SEGMENT[segment] ?? null
}
